module.exports = require('./TypographyContext');